import { ProductType } from "@/utils/types";
import { Card } from "antd";
import { QRCodeCanvas } from "qrcode.react";
import styles from "../../siteProductManagement.module.less";
import clsx from "clsx";

interface IExportQrPrint {
  type: "qrCode" | "rfidCode";
  productItem: ProductType;
}

function ExportQrPrint({ type, productItem }: IExportQrPrint) {
  return ( type === "qrCode" ?
    <div
      style={{
        padding: 2,
        paddingTop: 3,
        pageBreakAfter: "always",
        width: "100%",
        height: "100%",
      }}
    >
      <Card
        style={{
          borderWidth: 1,
          borderColor: "#CCCCCC",
          marginBottom: 4,
          width: "100% ",
          height: "100%",
          paddingLeft: 4,
          paddingRight: 4,
          paddingBlock: 4,
          pageBreakAfter: "always",
        }}
        styles={{ body: { padding: "0px 2px 0px 2px", display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" } }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 5,
            fontWeight: "bold",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "auto" }}>
            <QRCodeCanvas style={{ marginBottom: 3 }} size={60} value={JSON.stringify({ productId: productItem?.id })} />
          </div>
          <div style={{ textAlign: "left", marginLeft: 5, overflow: "hidden" }}>
            <div
              style={{
                fontWeight: 700,
                fontSize: 15,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {productItem?.masterProduct?.manufactureItemNumber}
            </div>
            <div
              className={clsx(styles.productName)}
              style={{
                fontSize: "0.59375rem",
                whiteSpace: "pre-wrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {productItem?.productName}
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            fontSize: 10,
            paddingTop: "4px",
            fontWeight: "bold",
          }}
        >
          <div>W/H:{productItem?.bin.warehouse?.identityCode}</div>
          <div>Bin: {productItem?.bin?.binCode}</div>
          <div>
            Pos:
            {productItem?.position}
          </div>
        </div>
      </Card>
    </div> : 
    <div
      style={{
        padding: 2,
        paddingTop: 3,
        pageBreakAfter: "always",
        width: "100%",
        height: "100%",
      }}
    >
      <Card
        style={{
          borderWidth: 1,
          borderColor: "#CCCCCC",
          marginBottom: 4,
          width: "100% ",
          height: "100%",
          paddingLeft: 4,
          paddingRight: 4,
          paddingBlock: 4,
          pageBreakAfter: "always",
        }}
        styles={{ body: { padding: "0px 2px 0px 2px", display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" } }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 5,
            fontWeight: "bold",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "auto" }}>
            <QRCodeCanvas style={{ marginBottom: 3 }} size={60} value={JSON.stringify({ rfidCode: productItem.rfidCode })} />
          </div>
          <div style={{ textAlign: "left", marginLeft: 5, overflow: "hidden" }}>
            <div
              style={{
                fontWeight: 700,
                fontSize: 15,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {productItem?.productName}
            </div>
            <div
              className={clsx(styles.productName)}
              style={{
                fontSize: "0.5rem",
                whiteSpace: "pre-wrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {productItem?.rfidCode}
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            fontSize: 10,
            paddingTop: "4px",
            fontWeight: "bold",
          }}
        >
          <div>W/H:{productItem?.bin.warehouse?.identityCode}</div>
          <div>Bin: {productItem?.bin?.binCode}</div>
          <div>
            Pos:
            {productItem?.position}
          </div>
        </div>
      </Card>
    </div>)
  ;
}

export default ExportQrPrint;
